<!-- 字典 -->
<template>
  <dict-input
    v-if="isEditor"
    v-model="value"
    :dict-key="item?.optionalValue"
    :dict-type="dictType"
    @change="mySubmit"
  />
  <dict-span v-else v-model="value" :dict-key="item?.optionalValue" :dict-type="dictType" />
</template>
<script>
import { defineComponent, computed } from 'vue'
import DictInput from '@/components/Dict/dictInput.vue'
import DictSpan from '@/components/Dict/dictSpan.vue'
import { baseProps, controlItemManage } from '../control-web/index'
export default defineComponent({
  name: 's-dict',
  inheritAttrs: true,
  components: { DictInput, DictSpan },
  props: { ...baseProps, modelValue: { type: String } },
  emits: ['update:modelValue', 'my-change'],
  setup(props, context) {
    const dictType = computed(() => {
      return parseInt(props.item?.fieldType) === 13 ? 1 : 2
    })
    return {
      ...controlItemManage(props, context),
      dictType
    }
  }
})
</script>
